import { useQuery } from "@apollo/client/react";

import { GetCurrentUserDocument } from "@/generated/graphql/graphql";

export function useRefetchCurrentUser() {
  const { refetch } = useQuery(GetCurrentUserDocument, { skip: true });

  return { refetch };
}
